import type { SVGProps } from 'react'
const SvgPencilEditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.21619 1.9498C9.1067 1.9498 8.99827 1.97137 8.89711 2.01327C8.79595 2.05518 8.70403 2.11659 8.6266 2.19402L2.58354 8.23708L2.14135 9.85846L3.76272 9.41626L9.80578 3.3732C9.88321 3.29577 9.94463 3.20386 9.98653 3.10269C10.0284 3.00153 10.05 2.89311 10.05 2.78361C10.05 2.67411 10.0284 2.56569 9.98653 2.46453C9.94463 2.36336 9.88321 2.27145 9.80578 2.19402C9.72836 2.11659 9.63644 2.05518 9.53528 2.01327C9.43411 1.97137 9.32569 1.9498 9.21619 1.9498ZM8.55269 1.18178C8.76305 1.09465 8.98851 1.0498 9.21619 1.0498C9.44388 1.0498 9.66934 1.09465 9.87969 1.18178C10.09 1.26891 10.2812 1.39663 10.4422 1.55762C10.6032 1.71862 10.7309 1.90976 10.818 2.12011C10.9052 2.33047 10.95 2.55592 10.95 2.78361C10.95 3.0113 10.9052 3.23675 10.818 3.44711C10.7309 3.65746 10.6032 3.8486 10.4422 4.0096L4.31461 10.1372C4.25924 10.1925 4.19037 10.2325 4.11482 10.2531L1.6184 10.9339C1.46261 10.9764 1.29599 10.9322 1.1818 10.818C1.06761 10.7038 1.02336 10.5372 1.06585 10.3814L1.7467 7.88499C1.7673 7.80943 1.80727 7.74057 1.86264 7.68519L7.99021 1.55762C8.15121 1.39663 8.34234 1.26891 8.55269 1.18178Z"
      fill="#464646"
    />
  </svg>
)
export default SvgPencilEditIcon
